import http from '@/utils/http'
import service from '@/http/service'

export default {
  url: `${service.merchant}/register`,
  checkParamsUnique(params) {
    return http.get(`${this.url}/review/checkParamsUnique`, params)
  }
}